import { Fragment, Node, Slice } from '@tiptap/pm/model'
import { Transform } from '@tiptap/pm/transform'

export const stripAllMarksFromSlice = (slice: Slice): Slice => {
  const newNodes: Node[] = []
  // todo - this works till 2nd level of depth, we might need to explore clearMarkup function https://github.com/ProseMirror/prosemirror/blob/89ca81f2352d66a72b2b179c9bb6ea01bedf6a01/src/transform/mark.js#L128 or implement our own depth update if we get such an issue
  slice.content.forEach((node) => {
    const { doc: updatedNode } = new Transform(node).removeMark(
      0,
      node.content.size,
      null
    )
    newNodes.push(updatedNode)
  })
  const newFrag = Fragment.fromArray(newNodes)
  return new Slice(newFrag, slice.openStart, slice.openEnd)
}
